<app-buscador></app-buscador>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h1 style="text-align:center;">&iexcl;RESULTADOS PARA TU B&uacute;SQUEDA!</h1>
            <h5 style="text-align:center;">Haz realizado una búsqueda de <b>[{{texto}}]</b></h5>
        </div>
    </div>
</div>

<div class="products">
    <div class="container">
        <div class="row">

            <div class="col-md-3 col-sm-6" *ngFor="let producto of listadoProductosSearch">
                <a class="product" [routerLink]="['/producto/' + producto.codigo.trim()]">
                    <img class="imgProducto" src="assets/imgs/productos/{{producto.codigo.trim()}}.jpg" alt="NO DISPONIBLE"  onerror="this.src='https://placehold.it/248x211?text=NO DISPONIBLE'"  />
                    <hr>
                    <div class="product-list-detail">
                        <h4>ID: {{producto.codigo.trim()}}</h4>
                        <h3 class="text-capitalize">{{producto.descripcion.trim().toLowerCase()}}</h3>
                        <h5><span class="current-price">Q{{producto.preNeto | number:'.2'}}</span></h5>
                    </div>
                </a>
            </div>

        </div>


        <div class="row" style="display: none">
            <div class="col-md-12">
                <a class="btn-general">VER M&Aacute;S PRODUCTOS</a>
                <a class="btn-general loading"><i class="fas fa-spinner"></i> CARGANDO PRODUCTOS</a>
            </div>
        </div>
    </div>
</div>